import { useEffect, useState } from "react";

interface UseLandscapeModeReturn {
    isLandscape: boolean;
}

export function useHandleLandscapeMode(): UseLandscapeModeReturn {
    const [isLandscape, setIsLandscape] = useState<boolean>(false);

    useEffect(() => {
        // Attempt to lock orientation (works in fullscreen/PWA contexts)
        try {
            (screen.orientation as any)?.lock("portrait").catch(() => {});
        } catch {
            // Silently fail — not supported
        }

        const query = window.matchMedia("(orientation: landscape) and (max-width: 768px)");

        const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
            setIsLandscape(e.matches);
        };

        // Set initial value
        handleChange(query);

        query.addEventListener("change", handleChange);

        return () => {
            query.removeEventListener("change", handleChange);
        };
    }, []);

    return { isLandscape };
}